<div class="modal-header">
    <h5 class="modal-title">Créer un nouveau Contenant</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"><i class="bi bi-x-circle-fill"></i></button>
</div>
<div class="modal-body">
    <form [formGroup]="bazarForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col-md-12">
                <div class="mb-3">
                    <label for="nom" class="form-label">Nom de l'objet</label>
                    <input type="text" id="nom" class="form-control" formControlName="nom" required>
                </div>
            </div>
       
            <div class="col-md-12 col-sm-12">
                <div class="mb-3">
                    <label for="prix" class="form-label">Prix</label>
                    <input type="number" id="prix" class="form-control" formControlName="prix" required>
                </div>
            </div>
        </div>
        
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
            <button type="submit" class="btn btn-primary" [disabled]="bazarForm.invalid">Créer</button>
        </div>
    </form>
</div>